export default "__VITE_ASSET__BjT13yBQ__"